var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRightSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99972 10C6.99972 9.74404 7.09769 9.48801 7.29269 9.29301C7.68369 8.90201 8.31575 8.90201 8.70675 9.29301L11.9997 12.586L15.2927 9.29301C15.6837 8.90201 16.3157 8.90201 16.7067 9.29301C17.0978 9.68401 17.0978 10.3161 16.7067 10.7071L12.7067 14.7071C12.3157 15.0981 11.6837 15.0981 11.2927 14.7071L7.29269 10.7071C7.09769 10.5121 6.99972 10.256 6.99972 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRightSmall);
export default __webpack_public_path__ + "static/media/angle-right-small.9be49289db061dedef47b38be7cb9939.svg";
export { ForwardRef as ReactComponent };